import React, { useEffect, useState } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
    Navigate,
} from "react-router-dom";
import { withCookies, useCookies } from "react-cookie";
import "../../sass/app.scss";
import Login from "./access/login";
import Home from "./home/home";
import CreateForm from "./forms/create/create";
import MyForms from "./forms/show/MyForms";
import logout from "./services/LoginService";
import Edit from "./forms/Edit/Edit";
import ProtectedRoute from "./access/ProtectedRoute";
import ProtectedLogin from "./access/ProtectedLogin";
import Panel from "./statistics/Panel";
import Details from "./statistics/Details";
import { BiLogOut } from "react-icons/bi";
import DarkMode from "./util/DarkMode";
import Companies from "./forms/companies/Companies";
import "bootstrap/dist/js/bootstrap.js";
const App = () => {
    const [cookie, setCookie, removeCookie] = useCookies([
        "token",
        "user",
        "dark",
    ]);
    const [showloading, setShowLoading] = useState(true);

    useEffect(() => {
        showloading
            ? (document.getElementById("loading").style.display = "flex")
            : (document.getElementById("loading").style.display = "none");
    }, [showloading]);

    return (
        <Router>
            {cookie.token && (
                <div>
                    <div id="nav-bar">
                        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
                            <div className="container-fluid">
                                <ul className="links navbar-nav">
                                    <li className="nav-item dropdown">
                                        <Link
                                            className="nav-link link"
                                            to="/new"
                                        >
                                            Nuevo Formulario
                                        </Link>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Link
                                            className="nav-link link"
                                            to="/my-forms"
                                        >
                                            Formularios
                                        </Link>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <Link
                                            className="nav-link link"
                                            to="/companies"
                                        >
                                            Empresas
                                        </Link>
                                    </li>
                                </ul>
                                <ul className="links navbar-nav gap-4">
                                    <li className="nav-item dropdown d-flex align-items-center">
                                        {/* <DarkMode /> */}
                                    </li>
                                    <li className="nav-item dropdown d-flex align-items-center">
                                        <BiLogOut
                                            onClick={() => {
                                                removeCookie(["token"], {
                                                    path: "/",
                                                });
                                                removeCookie(["user"], {
                                                    path: "/",
                                                });
                                                removeCookie(["url"], {
                                                    path: "/",
                                                });
                                                logout();
                                            }}
                                            size="1.4em"
                                            color={
                                                cookie.dark == "true"
                                                    ? "#fff"
                                                    : "#000"
                                            }
                                        />
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            )}
            <Routes>
                <Route exact path="/" element={<ProtectedLogin />}>
                    <Route
                        exact
                        path="/"
                        element={
                            <Login
                                showloading={showloading}
                                setShowLoading={setShowLoading}
                            />
                        }
                    ></Route>
                </Route>

                <Route exact path="/new" element={<ProtectedRoute />}>
                    <Route
                        exact
                        path="/new"
                        element={<CreateForm setShowLoading={setShowLoading} />}
                    ></Route>
                </Route>

                <Route exact path="/home" element={<ProtectedRoute />}>
                    <Route
                        exact
                        path="/home"
                        element={<Home setShowLoading={setShowLoading} />}
                    ></Route>
                </Route>
                <Route exact path="/my-forms" element={<ProtectedRoute />}>
                    <Route
                        exact
                        path="/my-forms"
                        element={<MyForms setShowLoading={setShowLoading} />}
                    ></Route>
                </Route>

                <Route exact path="/companies" element={<ProtectedRoute />}>
                    <Route
                        exact
                        path="/companies"
                        element={<Companies setShowLoading={setShowLoading} />}
                    ></Route>
                </Route>

                <Route exact path="/statistics" element={<ProtectedRoute />}>
                    <Route exact path="/statistics" element={<Panel />}></Route>
                </Route>

                <Route exact path="/update/:slug" element={<ProtectedRoute />}>
                    <Route
                        exact
                        path="/update/:slug"
                        element={<Edit setShowLoading={setShowLoading} />}
                    ></Route>
                </Route>

                <Route
                    exact
                    path="/form/export-db/:slug"
                    element={<ProtectedRoute />}
                >
                    <Route
                        exact
                        path="/form/export-db/:slug"
                        // element={<Edit setShowLoading={setShowLoading} />}
                    ></Route>
                </Route>

                <Route exact path="/details/:slug" element={<ProtectedRoute />}>
                    <Route
                        exact
                        path="/details/:slug"
                        element={<Details />}
                    ></Route>
                </Route>
            </Routes>
        </Router>
    );
};

export default withCookies(App);
